export interface IVideoState {
  loading: boolean;
  videoQueue: string[];
}

const defaultState = {
  loading: false,
  videoQueue: [],
};

export const getDefaultVideoState = () => defaultState;
